import { FaReact, FaNodeJs, FaHtml5, FaSass } from "react-icons/fa";
import { IoLogoJavascript } from "react-icons/io";
import { SiDocker, SiJfrog, SiJenkins, SiJava, SiPython, SiSpring, SiApachespark, SiTypescript, SiFastapi, SiMicrosoftazure, SiAmazonaws } from "react-icons/si";
import { ImGit } from "react-icons/im";
import {AiFillSchedule} from 'react-icons/ai';
export const SkillsData = [
  {
    name: "Java",
    icon: <SiJava color='#ffffffdc' />,
    link: "https://www.javascript.com/",
  },
  {
    name: "Python",
    icon: <SiPython color='#ffffffdc' />,
    link: "https://www.javascript.com/",
  },
  {
    name: "JavaScript",
    icon: <IoLogoJavascript color='#ffffffdc' />,
    link: "https://www.javascript.com/",
  },
  {
    name: "TypeScript",
    icon: <SiTypescript color='#ffffffdc' />,
    link: "https://www.javascript.com/",
  },
  {
    name: "Node.js",
    icon: <FaNodeJs color='#ffffffdc' />,
    link: "https://nodejs.org/",
  },
  {
    name: "Spring Boot",
    icon: <SiSpring color='#ffffffdc' />,
    link: "https://spring.io/",
  },
  {
    name: "FastAPI",
    icon: <SiFastapi color='#ffffffdc' />,
    link: "https://fastapi.tiangolo.com/",
  },
  {
    name: "React",
    icon: <FaReact color='#ffffffdc' />,
    link: "https://reactjs.org/",
  },
  {
    name: "Airflow",
    icon: <AiFillSchedule color='#ffffffdc' />,
    link: "https://airflow.apache.org/",
  },
  {
    name: "Spark",
    icon: <SiApachespark color='#ffffffdc' />,
    link: "https://spark.apache.org/",
  },
  {
    name: "Jfrog",
    icon: <SiJfrog color='#ffffffdc' />,
    link: "https://jfrog.com/",
  },
  {
    name: "Jenkins",
    icon: <SiJenkins color='#ffffffdc' />,
    link: "https://jenkins.io/",
  },
  {
    name: "Github",
    icon: <ImGit color='#ffffffdc' />,
    link: "https://git-scm.com/",
  },
  {
    name: "Docker",
    icon: <SiDocker color='#ffffffdc' />,
    link: "https://www.docker.com/",
  },
  {
    name: "Azure",
    icon: <SiMicrosoftazure color='#ffffffdc' />,
    link: "https://azure.microsoft.com/",
  },
  {
    name: "AWS",
    icon: <SiAmazonaws color='#ffffffdc' />,
    link: "https://aws.amazon.com/",
  }
];
